import { AuthHttp } from '../auth-http.service';
import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';

@Injectable()
export class NavService {

  constructor(private http: AuthHttp) {}

  setLanguage(language) {
    return this.http.get('user/language/' + language)
        .map((response) => response.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/core/nav/nav.service.ts